module.exports = __webpack_public_path__ + "app/assets/fonts/st-icons-web.ttf?f4ea64f002510a8e95a624591cc31824";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/st-icons-web.ttf
// module id = 182
// module chunks = 1